import { capitalCase } from "change-case";
import { isNumber } from "lodash";
import {
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useContext,
  useEffect,
} from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../../../components/button";
import { Flex } from "../../../../../components/layout";
import { StepperContext } from "../../../../../components/stepper/context";
import { device } from "../../../../../styles/media";
import { useTimeLeftToClaim } from "../../tiles/common";

interface IFormProps {
  setStake: Dispatch<SetStateAction<boolean>>;
}

const StyledDivider = styled.div`
  margin: 2em 0;
`;

const WrapperForm = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  padding: 0 2em;
  max-width: 100%;
  height: 100%;

  @media ${device.tablet} {
    width: 30em;
    height: 20em;
  }
`;

const CTA = styled(PrimaryButton).attrs({ fullWidth: true })`
  padding: 2em;
  margin: 0 2em;
`;

const Form: FunctionComponent<IFormProps> = ({ setStake }) => {
  const { setIsNextEnabled, next } = useContext(StepperContext);
  const timeLeft = useTimeLeftToClaim();

  useEffect(() => {
    setIsNextEnabled(false);
    return () => setIsNextEnabled(true);
  }, [setIsNextEnabled]);

  return (
    <WrapperForm>
      <CTA
        disabled={true}
        variant="contained"
        onClick={() => {
          setStake(true);
          next.next();
        }}
      >
        <strong>CLAIM and RE-LOCK</strong>
      </CTA>
      <StyledDivider>or</StyledDivider>
      <CTA
        variant="outlined"
        onClick={() => {
          setStake(false);
          next.next();
        }}
        disabled={timeLeft.isDefined()}
      >
        {timeLeft.fold(
          () => (
            <strong>CLAIM</strong>
          ),
          (remaining) =>
            `${isNumber(remaining) ? `${remaining} Days` : capitalCase(remaining)
            } Left To Claim`
        )}
      </CTA>
    </WrapperForm>
  );
};

export default Form;
